const API_URL = window.location.origin || '';

const headers = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
};

export const infantilAPI = {
  bootstrap: () => fetch(`${API_URL}/api/infantil360/bootstrap`, { method: 'POST', headers: headers() }).then(r => r.json()),
  reference: () => fetch(`${API_URL}/api/infantil360/reference`, { headers: headers() }).then(r => r.json()),
  dashboard: (year = 2026, tri = '1º Trimestre') =>
    fetch(`${API_URL}/api/infantil360/dashboard?year=${year}&trimester=${encodeURIComponent(tri)}`, { headers: headers() }).then(r => r.json()),
  classes: (year = 2026) => fetch(`${API_URL}/api/infantil360/classes?year=${year}`, { headers: headers() }).then(r => r.json()),
  classStudents: (classId) => fetch(`${API_URL}/api/infantil360/classes/${classId}/students`, { headers: headers() }).then(r => r.json()),
  observations: {
    list: (params = {}) => {
      const q = new URLSearchParams(params).toString();
      return fetch(`${API_URL}/api/infantil360/observations?${q}`, { headers: headers() }).then(r => r.json());
    },
    get: (id) => fetch(`${API_URL}/api/infantil360/observations/${id}`, { headers: headers() }).then(r => r.json()),
    create: (data) => fetch(`${API_URL}/api/infantil360/observations`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
    update: (id, data) => fetch(`${API_URL}/api/infantil360/observations/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
    delete: (id) => fetch(`${API_URL}/api/infantil360/observations/${id}`, { method: 'DELETE', headers: headers() }).then(r => r.json()),
  },
  student360: (studentId, tri = '1º Trimestre') =>
    fetch(`${API_URL}/api/infantil360/student/${studentId}/360?trimester=${encodeURIComponent(tri)}`, { headers: headers() }).then(r => r.json()),
  portfolios: {
    list: (params = {}) => {
      const q = new URLSearchParams(params).toString();
      return fetch(`${API_URL}/api/infantil360/portfolios?${q}`, { headers: headers() }).then(r => r.json());
    },
    create: (data) => fetch(`${API_URL}/api/infantil360/portfolios`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  reports: {
    list: (params = {}) => {
      const q = new URLSearchParams(params).toString();
      return fetch(`${API_URL}/api/infantil360/reports?${q}`, { headers: headers() }).then(r => r.json());
    },
    create: (data) => fetch(`${API_URL}/api/infantil360/reports`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
};
